"use strict";

(function ($) {

    class ProtectedDownloads {

        constructor(){

            let self = this;

            $('.post-password').submit(function(ev) {
                ev.preventDefault();

                let index = $(this).closest('.file-item').data('index');
                let id = $(this).closest('.file-item').data('id');
                let password = $(this).find('input[type=password]').val();


                self.validate($(this), {
                    index: index,
                    id: id,
                    password: password
                });
            });
        }

        validate(element, settings) {

            let self = this;

            $.ajax({
                url: variables.ajaxurl,
                type: "post",
                data: {
                    action: 'protected_downloads',
                    settings: settings
                },
                beforeSend: function () {
                },
                success: function (data) {

                    let response = JSON.parse(data);

                    if (response.error) {
                        self.validate_message(element);
                    }

                    else {
                        window.open(response.file_url, "_self");
                    }
                },
                error: function (data) {
                    console.error("error!");
                }
            });
        }


        validate_message(element){

            let self = this;

            if (!(element.find('.validate-error').length > 0)) {
                element.append('<span class="validate-error">Wrong password</span>')
            }
        }
    }


    let protected_downloads = new ProtectedDownloads();



    // $('[data-downloadable]').on('click', function (e) {
    //
    //     e.preventDefault();
    //
    //     downloadable.generatePDF({
    //         id: $(this).data('id'),
    //         field: $(this).data('field'),
    //         sub_field: $(this).data('sub-field'),
    //         sub_field_row: $(this).data('sub-field-row'),
    //         article_name: $(this).data('article-name'),
    //         content_type: $(this).data('content-type')
    //     });
    //
    //
    // });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/ProtectedDownloads.es6